import _taggedTemplateLiteral from "/home/opc/is-monorepo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  fragment realizationPlanInfo on RealizationPlan {\n    realization\n    plan\n    category {\n      id\n      code\n      name\n    }\n  }\n"]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
import gql from 'graphql-tag';
export default gql(_templateObject());